/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { useContext, useState, useCallback, useEffect } from "react";
import { validateEmail } from "../../../CommonMethods/EmailValidator";
import GlobalContext from "../../../components/Context/GloablContext";
import Loader from "../../../components/Loader";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { dataService } from "../../../services/data.services";
import CardHeader from "../../../components/CardHeader";
import Toast from "../../../components/Toast";
import BasicDetails from "./Components/AddStudentComponents/BasicDetails";
import ContactDetails from "./Components/AddStudentComponents/ContactDetails";
import AcademicDetails from "./Components/AddStudentComponents/AcademicDetails";
import CustomOverLay from "../../../components/CustomOverlay";
import FeeStructure from "./Components/AddStudentComponents/FeeStructure";
import { GetBranchId } from "../../../CommonMethods/GetBranchId";
import { distributeAmounts, distributeDivision } from "./Components/AddStudentComponents/distributeDivisionFeeTerm";
import moment from "moment";
export default function AddStudent({ edit }) {
    const {
        setToastmessage,
    } = useContext(GlobalContext);
    const location = useLocation();
    const { state: myRedirection } = location;
    const navigate = useNavigate();
    const [feeStructureLoading,  setFeeStructureLoading] = useState(false)
    const [sectionsLoading, setSectionsLoading] = useState(false)
    const [editData, seteditData] = useState({});
    const [loading, setloading] = useState(false);
    const [toastErrorMessage,setToastErrorMessage] = useState('')
    const [parentDetails, setParentDetails] = useState({
        father_image_url:"",
        father_first_name: "",
        father_middle_name: "",
        father_last_name: "",
        father_email_address: "",
        father_mobile_number: "",
        father_pan_number: "",
        father_aadhar_number: "",
        father_aadhar_file: "",
        mother_image_url:"",
        mother_first_name: "",
        mother_middle_name: "",
        mother_last_name: "",
        mother_email_address: "",
        mother_mobile_number: "",
        mother_pan_number: "",
        mother_aadhar_number: "",
        mother_aadhar_file: "",
        student_aadhar_number: '',
        student_aadhar_file: '',
        emergency_contact_name: '',
        emergency_contact_mobile_number: '', 
        send_father_invite: false,
        send_mother_invite: false,
    });
    const handleParentCheckbox = (key) => {
        setParentDetails((prev) => ({
            ...prev,
            [key]: !prev[key],
        }));
    };

    const [selectedObjects, setSelectedObjects] = useState([]);
    const [loadingPage, setLoadingPage] = useState(true);
    const initialState = {
        image_url: "",
        first_name: "",
        middle_name: "",
        last_name: "",
        date_of_birth: "",
        blood_group: "",
        gender: "",
        date_of_admission: "",
        nationality: "",
        economic_status: "",
        religion: "",
        caste: "",
        caste_category: "",
        registration_number: "",
        address_line1: "",
        address_line2: "",
        pin_code: "",
        area: "",
        city: "",
        state: "",
        mobile_number: "",
        email_address: "",
        is_father_details: false,
        is_mother_details: false,
        "academic_year": {
            "name": "",
            "start_date": "",
            "end_date": "", 
            "status": ""
        },
        "classes": {
            "class_id": "",
            "class_name": ""
        },
        "sections": {
            "section_id": "",
            "section_name": ""
        },
        "mandatory_subject": [
            {
                "subject_id": "",
                "subject_name": ""
            }
        ],
        "optional_subject" : [
            {
                "subject_id": "",
                "subject_name": "",
                "amount": ""
            }
        ]
        
    };
    const [showDropdown, setshowDropdown] = useState({
        blood_group: false,
        gender: false,
        economic_status: false,
        religion: false,
        caste_category: false,
        academic_year: false,
        class: false,
        section: false,
    });
    const [isValidation, setIsValidation] = useState(false);
    const [studentDetails, setStudentDetails] = useState(initialState);
    const [tabs, settabs] = useState("basic");
    const [stateStatus,setStateStatusDisable]=useState(true)
    const [submitSelected, setsubmitSelected] = useState(false);
    const [imageSizeInfoHover, setImageSizeInfoHover] = useState(false);
    const [customError, setcustomError] = useState([]);
    const [formatError, setformatError] = useState('');
    const [imageLoading, setimageLoading] = useState('');
    const [params, setParams] = useState('')
    const tabArray = ["Basic", "Contact", "Academic", "Fee Structure"]
    const [academicYear, setAcademicYear] = useState([]);
    const [classes, setClasses] = useState([]);
    const [hasStartDateBegun, setHasStartDateBegun] = useState(false);
    const [selectedSection, setSelectedSection] = useState(null);
    const [optionalSubjects, setOptionalSubjects] = useState([]);
    const [mandatorySubjects, setMandatorySubjects] = useState([]);
    const [selectedFeeTermData, setSelectedFeeTermData] = useState({})
    const [selectedDropDownValue, setSelectedDropDownValue] = useState('');
    const [feeStructure, setFeeStructure] = useState([]);
    const [updatedFeeData, setUpdatedFeeData] = useState([]);
    const [tabAllArray, setTabAllArray] = useState(["basic"])
    const [sections,setSections]=useState([])
    const [selectedSections,setSelectedSections]=useState([])
    const [sectionName, setSectionName] =useState('');
    const [didDropDownChange, setDidDropDownChange] = useState(false)
    const [didAcademicDropDownChange, setAcademicDidDropDownChange] =useState(false)
    const [isStudentDataUploaded, setIsStudentDataUploaded] = useState(false)
    const [isSelectFeeTermDropdown, setIsSelectFeeTermDropdown] = useState(false);
    let {id} = useParams();
    const panCardRegex = /[A-Z]{5}[0-9]{4}[A-Z]{1}/;
    const [branch_id, setBranchId] = useState(JSON.parse(localStorage.getItem("branch_details"))?.id)
    const [branch_name, setBranchName] = useState(JSON.parse(localStorage.getItem("branch_details"))?.name)

    /**
     * The function `handlePanCheck` checks if a given PAN number (Indian Permanent Account Number)
     * matches a regular expression pattern.
     * @returns a boolean value indicating whether the given `pan_number` matches the regular
     * expression `panCardRegex`.
     */
    const handlePanCheck=(pan_number)=>{
        return panCardRegex.test(pan_number)
    }

    /**
     * The function "handleUploadAadhaar" sets the "editData" state to an object with an empty "name"
     * property.
     */
    const handleUploadAadhaar = (id) => {
        seteditData({"name" : ""})
    };

    /**
     * The function `handleInput` is used to update the `studentDetails` state object with the new
     * value entered in an input field, while also resetting some other related state variables.
     */
    const handleInput = (e, val, idd) => {
        setToastErrorMessage('')
        setIsValidation(false)
        const { id, value } = e.target;
        setStudentDetails((prv) => ({
            ...prv,
            [id]: value,
        }));
    };

    /**
     * The function `handleParentInput` is used to handle input changes for parent details, including
     * converting PAN numbers to uppercase.
     */
    const handleParentInput = (e, val, idd) => {
        setToastErrorMessage('')
        setIsValidation(false);
        let { id, value } = e.target;
        if(id === "father_pan_number" || id === 'mother_pan_number') {
            value = value.toUpperCase();
        }
        setParentDetails((prv) => ({
            ...prv,
            [id]: value,
        }));
    };

    /**
     * The function `handleDropdown` toggles the visibility of a dropdown menu and resets the error
     * message, submit status, and dropdown state accordingly.
     */
    const handleDropdown = (key) => {
        setToastErrorMessage('')
        setsubmitSelected(false);
        setshowDropdown((prv) => ({
            ...prv,
            [key]: !showDropdown[key],
        }));
    };


    /**
     * The function `handleCheckbox` is used to handle checkbox changes and update the state variables
     * `studentDetails` and `parentDetails` accordingly.
     */
    const handleCheckbox = (id) => {
        setToastErrorMessage("");
        if(id === 'is_father_details'){
            setStudentDetails((prv) => ({
                ...prv,
                [id]: !prv[id],
            }));
            setParentDetails((prv) => ({
                ...prv,
                father_image_url:"",
                father_first_name: "",
                father_middle_name: "",
                father_last_name: "",
                father_email_address: "",
                father_mobile_number: "",
                father_pan_number: "",
                father_aadhar_number: "",
                father_aadhar_file: "",
            }));
        } else{
            setStudentDetails((prv) => ({
                ...prv,
                [id]: !prv[id],
            }));
            setParentDetails((prv) => ({
                ...prv,
                mother_image_url:"",
                mother_first_name: "",
                mother_middle_name: "",
                mother_last_name: "",
                mother_email_address: "",
                mother_mobile_number: "",
                mother_pan_number: "",
                mother_aadhar_number: "",
                mother_aadhar_file: "",
            }));
        }
    }    

    /**
     * The function `handleTabs` handles the logic for switching between different tabs in a form,
     * performing validations and displaying error messages if necessary.
     * @returns The function does not have a return statement.
     */
    const handleTabs = (key) => {
        setToastErrorMessage("")
        let arr = key ==="basic" ? ["basic"] : tabAllArray;
        if(tabs === 'basic' || tabs ==='contact'){
            if(edit &&!hasStartDateBegun){
                if(key==='fee structure'){
                    settabs('academic')
                    return
                }
            }
        }
        if(tabs === 'contact' && key === 'basic'){
            settabs('basic')
            return
        }
        else if(tabAllArray.includes("academic") || key ==="basic") {
            if (tabs === "contact" && key === "academic" && !studentDetails.is_father_details && !studentDetails.is_mother_details) {
                if(!handleValidation){
                    setsubmitSelected(true);
                    setToastErrorMessage('Please fill in all the mandatory fields')
                    return
                }else if(handleAllValiadation()){
                    setIsValidation(true)
                    setsubmitSelected(true)
                    setToastErrorMessage("Please enter valid details");                
                    return
                }else{
                    setsubmitSelected(true);
                    setToastErrorMessage('Please fill in all the fields under either one or both parent details')
                    return 
                } 
            } else if(tabs === 'academic' && key ==='fee structure' && sectionName === '' ){
                setsubmitSelected(true)
                setToastErrorMessage('Please fill in all the mandatory fields')
                return
            } else if (tabs === 'contact' && key === 'fee structure' && (sectionName === '' || studentDetails.sections.section_name === '')){
                settabs('academic')
                setsubmitSelected(true);
                setToastErrorMessage('Please fill in all the mandatory fields')
                return
            } else {
                if(!handleValidation){
                    setsubmitSelected(true);
                    setToastErrorMessage('Please fill in all the mandatory fields')
                    return
                }else if(handleAllValiadation()){
                    setIsValidation(true)
                    setsubmitSelected(true)
                    setToastErrorMessage("Please enter valid details");          
                    return
                } else {settabs(key);
                    arr.push(key);
                    arr = [...new Set(arr)]
                    setTabAllArray(arr)
                    setsubmitSelected(false);
                }
            }
        }else if(!handleValidation()) {
            if(tabs === 'fee structure' && key === 'academic'){
                settabs('academic')
                return
            } else if(tabs === 'fee structure' && key === 'fee structure'){
                settabs('fee structure')
                return
            } else{
                setsubmitSelected(true);
                setToastErrorMessage('Please fill in all the mandatory fields')
                return
            }
        }else if(handleAllValiadation()){
            if(tabs === 'fee structure' && key === 'academic'){
                settabs('academic')
                return
            } else if(tabs === 'fee structure' && key === 'fee structure'){
                settabs('fee structure')
                return
            } else{
                setIsValidation(true)
                setsubmitSelected(true)
                setToastErrorMessage("Please enter valid details");
                return
            }
        }else if (tabs === "contact" && key === "academic" && !studentDetails.is_father_details && !studentDetails.is_mother_details) {
            setsubmitSelected(true);
            setToastErrorMessage('Please fill in all the fields under either one or both parent details')
            return
        } else if(key === "academic" && studentDetails.pin_code === "") {
            if (tabs === 'basic' && key === "academic" && studentDetails.address_line1 === ''){
                settabs('contact')
                setsubmitSelected(true);
                setToastErrorMessage('Please fill in all the mandatory fields')
                return
            } else if (tabs === 'basic' && key === 'fee structure' && (sectionName === '' || studentDetails.sections.section_name === '')){
                settabs('contact')
                setsubmitSelected(true);
                setToastErrorMessage('Please fill in all the mandatory fields')
                return
            } else {
                let arr = tabAllArray
                settabs(key);
                arr.push(key);
                arr = [...new Set(arr)]
                setTabAllArray(arr)
                setsubmitSelected(false);
                return
            }
        
        } else if(edit && tabs === 'basic' && (key === 'fee structure' || key === 'academic')){
            if((!studentDetails.is_father_details && !studentDetails.is_mother_details) || studentDetails.state === ""){
                settabs('contact')
                setsubmitSelected(true);
                setToastErrorMessage('Please fill in all the mandatory fields')
                return
            }
            else if(sectionName === ''){
                if(studentDetails?.sections?.section_name !== '' && key === 'fee structure'){
                    settabs('fee structure')
                    return
                } else{
                    settabs('academic')
                    setsubmitSelected(true);
                    studentDetails?.sections?.section_name === '' && setToastErrorMessage('Please fill in all the mandatory fields')
                    return
                }
            }
            else{
                if(key==='academic'){
                    settabs('academic')
                } else{
                    settabs('fee structure')
                }
            }
        } else if(tabs === 'academic' && key === 'contact'){
            settabs('contact')
            return
        } else if(tabs === 'contact' && key === 'fee structure' && (sectionName === '' || studentDetails.sections.section_name === '')){
            settabs('academic')
            setsubmitSelected(true);
            setToastErrorMessage('Please fill in all the mandatory fields')
            return
        } else if (tabs === 'basic' && key === 'fee structure' && ((!studentDetails.is_father_details && !studentDetails.is_mother_details) || studentDetails.state === "")){
            settabs('contact')
            setsubmitSelected(true);
            setToastErrorMessage('Please fill in all the mandatory fields')
            return
        } else if (tabs === 'basic' && key === 'fee structure' && (sectionName === '' || studentDetails.sections.section_name === '')){
            settabs('academic')
            setsubmitSelected(true);
            setToastErrorMessage('Please fill in all the mandatory fields')
            return
        } else if (tabs === 'contact' && key === 'fee structure' && (sectionName === '' || studentDetails.sections.section_name === '')){
            settabs('academic')
            setsubmitSelected(true);
            setToastErrorMessage('Please fill in all the mandatory fields')
            return
        } else {
            let arr = tabAllArray
            settabs(key);
            arr.push(key);
            arr = [...new Set(arr)]
            setTabAllArray(arr)
            setsubmitSelected(false);
        }
    }  

    /**
     * The `cancelHandler` function determines the redirection path based on certain conditions and
     * navigates accordingly in a React application.
     */
    const cancelHandler = () => {
        if(edit){
            if(myRedirection?.redirect === 'fromViewScreen'){
                navigate(`/student-master/directory/${id}?${params}`)
            } else {
                navigate(`/student-master/directory?${params}`)
            }
        } else{ 
            navigate('/student-master/directory')
        }
    }

    /**
     * The function `handleDropDownValue` updates the `studentDetails` state with a new value for a
     * given key and then calls the `handleDropdown` function.
     */
    const handleDropDownValue = (key, value) => {
        setStudentDetails((prv) => ({
            ...prv,
            [key]: value,
        }));
        handleDropdown(key);
    };
    
    /**
         * The function `handleSelectedDate` updates the `studentDetails` state by setting the value of a
         * specific key (`id`) to a selected date (`dateString`).
         */
    const handleSelectedDate = (id, date, dateString) => {
        setStudentDetails((prv) => ({
            ...prv,
            [id]: dateString,
        }));
    };

    /**
     * The `trimObjectStrings` function recursively trims whitespace from all string values within an
     * object or array.
     * @returns The `trimObjectStrings` function takes an input object and trims any string values within
     * the object. If the input is a string, it trims the string and returns it. If the input is an array,
     * it maps over the array and trims any string values recursively. If the input is an object, it
     * recursively trims string values in all nested objects and returns a new object with
     */
    const trimObjectStrings = (obj) => {
        if (typeof obj === 'string') {
            return obj?.trim();
        } else if (Array.isArray(obj)) {
            return obj?.map(trimObjectStrings);
        } else if (typeof obj === 'object' && obj !== null) {
            return Object?.keys(obj)?.reduce((acc, key) => {
                acc[key] = trimObjectStrings(obj[key]);
                return acc;
            }, {});
        }
        return obj;
    };

    /**
     * The function `handleValidation` checks if all the required fields in a form are filled out and
     * returns true if they are, otherwise it returns false.
     * @returns a boolean value. It returns true if all the required fields are filled in, and false if
     * there are any missing fields.
     */
    const handleValidation = () => {
        const arr = [];
        const mykeys = {
            first_name: "",
            date_of_birth: "",
            blood_group: "",
            gender: "",
            date_of_admission: "",
            nationality: "",
            economic_status: "",
            religion: "",
            caste: "",
            caste_category: "",
        };
        let tab2keys={
            address_line1: "",
            address_line2: "",
            pin_code: "",
            area: "",
            city: "",
            state: "",
            mobile_number: "",
            email_address: ''
        }
        if(tabs !== "academic") {
            Object.keys(tabs === 'basic' ? mykeys : tab2keys).map((item) => {
                if(tabs === "contact") {
                    if(studentDetails.is_father_details && parentDetails.father_first_name === "") {
                        arr.push("father_first_name");
                    }
                    if(studentDetails.is_mother_details && parentDetails.mother_first_name === "") {
                        arr.push("mother_first_name");
                    }
                    if(studentDetails.is_father_details && parentDetails.father_pan_number === "") {
                        arr.push("father_first_name");
                    }
                    if(studentDetails.is_mother_details && parentDetails.mother_pan_number === "") {
                        arr.push("father_pan_number");
                    }
                    if(studentDetails.is_father_details && parentDetails.father_email_address === "") {
                        arr.push("father_email_address");
                    }
                    if(studentDetails.is_mother_details && parentDetails.mother_email_address === "") {
                        arr.push("mother_email_address");
                    }
                }
                if (studentDetails[item] === "") {
                    arr.push(item);
                }
            });
        } else {
            if(studentDetails.academic_year.name === "") {
                arr.push("academic_year")    
            } else if(studentDetails.classes.class_name === "") {
                arr.push("classes")    
            } else if(studentDetails.sections.section_name === "") {
                arr.push("sections")   
            }
        }
        setcustomError(arr)
        return arr?.length === 0;
    };
    
    /**
     * The function `handleAllValidation` checks for various validations based on the selected tab and
     * returns a flag indicating if any validation errors were found.
     * @returns a boolean value. If the `tabs` variable is equal to "academic", it returns `false`.
     * Otherwise, it returns the value of the `flag` variable.
     */
    const handleAllValiadation = () => {
        let flag = false
        const array =  tabs === "basic" ? 
            ['student_aadhar_number'] :  
            ['pin_code', 'email_address', 'mobile_number', 'mother_pan_number','father_pan_number', 'student_aadhar_number','emergency_contact_mobile_number','father_email_address','mother_email_address','father_aadhar_number', 'mother_aadhar_number', 'mother_mobile_number','father_mobile_number'] 
        let allArray = []
        array.forEach((item) => {
            switch (item) {
            case "fee-structure":
                if(feeStructure?.length === 0) {
                    flag = true;   
                    allArray.push(item)  
                }
                break;
            case "mother_pan_number":
            case "father_pan_number":
                if(!handlePanCheck(parentDetails[item]) && parentDetails[item] !== "") {
                    flag = true;   
                    allArray.push(item)  
                }
                break;
            case "father_mobile_number":
            case "mother_mobile_number":
            case "emergency_contact_mobile_number":
                if(parentDetails[item] !== "" && (parentDetails[item]?.length <10) || (parentDetails[item]?.length > 10)) {
                    flag = true;  
                    allArray.push(item) 
                }
                break;
            case "email_address":
                if(validateEmail(studentDetails.email_address) ) {
                    flag = true;  
                    allArray.push(item)  
                }
                break;
            case "father_email_address":
            case "mother_email_address":
                if(parentDetails[item] !== "" && validateEmail(parentDetails[item]) ) {
                    flag = true;  
                    allArray.push(item)  
                }
                break;
            case "mobile_number":
                if((studentDetails[item]?.length <10) || (studentDetails[item]?.length > 10)) {
                    flag = true;  
                    allArray.push(item) 
                }
                break;
            case "pincode":
                if(studentDetails.pin_code !== '' && studentDetails.pin_code?.length !== 6) {
                    flag = true;  
                    allArray.push(item)    
                }
                break;     
            case "student_aadhar_number":
                if(parentDetails.student_aadhar_number !== '' && parentDetails.student_aadhar_number?.length !== 12) {
                    flag = true;  
                    allArray.push(item)    
                }
                break;     
            case "father_aadhar_number":
                if(parentDetails.father_aadhar_number !== '' && parentDetails.father_aadhar_number?.length !== 12) {
                    flag = true;  
                    allArray.push(item)    
                }
                break;  
            case "mother_aadhar_number":
                if(parentDetails.mother_aadhar_number !== '' && parentDetails.mother_aadhar_number?.length !== 12) {
                    flag = true;  
                    allArray.push(item)    
                }
                break;                   
            default:
                break;
            }
        })
        setcustomError(allArray);
        return tabs === "academic" ? false : flag
    } 

    /**
     * The function `handleSaveAndProcced` is used to handle the saving and processing of student
     * details in a React application.
     * @returns The function `handleSaveAndProcced` does not have a return statement.
     */
    const handleSaveAndProcced = async () => {
        setsubmitSelected(true);
        setIsValidation(false);
        handleValidation();
        if (!handleValidation()) {
            setToastErrorMessage("Please fill in all the mandatory fields");
            return;
        } else if (tabs === "contact" && !studentDetails.is_father_details && !studentDetails.is_mother_details) {
            if (!studentDetails.is_father_details && !studentDetails.is_mother_details) {
                setToastErrorMessage("Please fill in all the fields under either one or both parent details");
                return;
            }
        } else if (handleAllValiadation()) {
            setIsValidation(true);
            setToastErrorMessage("Please enter valid details");
            return;
        }else if (tabs === "contact") {
            if (!studentDetails.is_father_details && !studentDetails.is_mother_details) {
                setToastErrorMessage("Please fill in all the fields under either one or both parent details");
                return;
            } else {
                setTabAllArray(["basic", "contact", "academic"]);
                settabs("academic");
                setsubmitSelected(false);

            }
        } else if (tabs === "basic") {
            setTabAllArray(["basic", "contact"]);
            settabs("contact");
            setsubmitSelected(false);

        } else if (tabs === "academic") {
            setTabAllArray(["basic", "contact", "academic", "fee structure"]);
            settabs("fee structure");
            setsubmitSelected(false);
            !edit && setSelectedDropDownValue('')
        }  else {
            try {
                setloading(true)
                let endpoint;
                let body = studentDetails;
                const branch_id = await GetBranchId()
                body["branch_id"] = branch_id
                body["branch_name"] = branch_name
                body["aadhar_number"] = {
                    number: parentDetails.student_aadhar_number,
                    file: parentDetails.student_aadhar_file,
                },
                body["fee_structure"] = studentDetails?.fee_structure 
                body["fee_term"] = studentDetails?.fee_term 
                body["emergency_contact"] = {
                    name: parentDetails.emergency_contact_name,
                    mobile_number: parentDetails.emergency_contact_mobile_number,
                }
                body["father_details"] = {
                    first_name: parentDetails.father_first_name,
                    middle_name: parentDetails.father_middle_name,
                    last_name: parentDetails.father_last_name,
                    email_address: parentDetails.father_email_address,
                    mobile_number: parentDetails.father_mobile_number,
                    pan_number: parentDetails.father_pan_number,
                    aadhar_number: {
                        number: parentDetails.father_aadhar_number,
                        file: parentDetails.father_aadhar_file,
                    },
                    father_image_url: parentDetails.father_image_url,
                }
                body["send_father_invite"] = parentDetails.send_father_invite || false
                body["send_mother_invite"] = parentDetails.send_mother_invite || false
                body["mother_details"] = {
                    first_name: parentDetails.mother_first_name,
                    middle_name: parentDetails.mother_middle_name,
                    last_name: parentDetails.mother_last_name,
                    email_address: parentDetails.mother_email_address,
                    mobile_number: parentDetails.mother_mobile_number,
                    pan_number: parentDetails.mother_pan_number,
                    aadhar_number: {
                        number: parentDetails.mother_aadhar_number,
                        file: parentDetails.mother_aadhar_file,
                    },
                    mother_image_url: parentDetails.mother_image_url,
                }
                if (!hasStartDateBegun) {
                    body["optional_subject"] = selectedObjects;
                    const result = [];
                    
                    feeStructure?.length !== 0 && feeStructure[0]?.fees.forEach(item => {
                        result?.push({
                            "feehead_name": item?.fee_head.trim(),
                            "feehead_amount": item?.amount,
                            "fee_head_id": item?.fee_head_id
                        });
                    });
                    
                    if (selectedFeeTermData?.length !== 0 && selectedDropDownValue !== '') {
                        if (result.length !== 0) {
                            body["fee_structure"] = { "fee_head": result, total_amount: feeStructure[0]?.cumulative_amount.toString() };
                        }
                        
                        const mappedData = [];
                        
                        if (edit) {
                            if (didDropDownChange) {
                                selectedFeeTermData?.terms?.forEach((term, index) => {
                
                                    const mappedTerm = {
                                        feeterm_name: selectedFeeTermData?.fee_term_name,
                                        term_name: `Term ${index + 1}`, // This keeps the original index
                                        fee_head: feeStructure[0].fees?.map((feeHead) => ({
                                            feehead_name: feeHead.fee_head,
                                            fee_head_id: feeHead?.fee_head_id,
                                            feehead_amount: parseFloat(distributeDivision(feeHead.amount, selectedFeeTermData.number_of_fee_terms, selectedFeeTermData.number_of_fee_terms)[index]).toFixed(2),
                                        })),
                                        total_amount: parseFloat(distributeAmounts(feeStructure[0]?.fees, selectedFeeTermData.number_of_fee_terms, "amount", index)).toFixed(2),
                                        start_date: term.start_date,
                                        end_date: term.end_date,
                                    };
                                    mappedData?.push(mappedTerm);
                                });
                            }
                
                            body["fee_term"] = mappedData;
                        } else {
                            selectedFeeTermData?.terms?.forEach((term, index) => {
                
                                const mappedTerm = {
                                    feeterm_name: selectedFeeTermData.fee_term_name,
                                    term_name: `Term ${index + 1}`, // This keeps the original index
                                    fee_head: feeStructure[0].fees?.map((feeHead) => ({
                                        feehead_name: feeHead.fee_head,
                                        fee_head_id: feeHead?.fee_head_id,
                                        feehead_amount: parseFloat(distributeDivision(feeHead.amount, selectedFeeTermData.number_of_fee_terms, selectedFeeTermData.number_of_fee_terms)[index]).toFixed(2),
                                    })),
                                    total_amount: parseFloat(distributeAmounts(feeStructure[0]?.fees, selectedFeeTermData.number_of_fee_terms, "amount", index)).toFixed(2),
                                    start_date: term.start_date,
                                    end_date: term.end_date,
                                };
                                mappedData.push(mappedTerm);
                            });
                
                            body["fee_term"] = mappedData;
                        }
                    } else {
                        // Optional: Handle the case where no fee terms or dropdown values are selected
                        // body["fee_structure"] = null;
                        // body["fee_term"] = [];
                    }
                } else {
                    delete body["fee_structure"];
                    delete body["fee_term"];
                }
                
                // Check if mandatory_subject is empty and set it to an empty array
                if (!body.mandatory_subject || body.mandatory_subject.length === 0) {
                    body.mandatory_subject = [];
                }
                let existingData;
                if (edit) {
                    const res = await dataService.GetAPI(`students/${id}`, true);
                    existingData = res.data.data;
                }
                Object.keys(studentDetails).forEach((field) => {
                    if (edit && existingData && existingData[field] !== studentDetails[field]) {
                        body[field] = studentDetails[field];
                    }
                });
                let response;
                body = trimObjectStrings(body);
                if (edit) {
                    delete body.is_father_invite_sent;
                    delete body.is_mother_invite_sent;
                    delete body._id
                    delete body.student_id
                    delete body.full_name
                    if(body["fee_term"]?.length === 0) delete body["fee_term"]
                    if (selectedDropDownValue === ''){
                        body["fee_term"] = []
                        body['fee_term_id'] = null
                    }
                    endpoint=`students/${id}`
                    response = await dataService.PatchAPI(body, endpoint)
                } else{
                    endpoint='students'
                    response = await dataService.PostAPI(body, endpoint)
                }
                setloading(false);
                // Check the edit status and redirection conditions
                if (edit) {
                    if (myRedirection?.redirect === 'fromViewScreen') {
                        navigate(`/student-master/directory/${id}?${params}`);
                    } else {
                        navigate(`/student-master/directory?${params}`);
                    }
                } else { 
                    navigate('/student-master/directory');
                }
                setToastmessage(edit ? "Student updated successfully" : response.data.data.message);
            } catch(error){
                setloading(false);
                setToastErrorMessage(error?.response?.data?.message || "Something went wrong");
                console.log(error)
            }
        }
    };

    /* The above code is a JavaScript React function called `getViewDetails`. It is an asynchronous
    function that makes an API call to retrieve student details based on an `id`. */
    const getViewDetails = useCallback(
        async() => {
            try {
                const res= await dataService.GetAPI(`students/${id}`, true);
                setStudentDetails(res.data.data.data);
                Object.keys(initialState)?.map((item) => {
                    if(Object.keys(res?.data?.data?.data).includes(item)) {
                        setStudentDetails((prv) => ({
                            ...prv,
                            [item]: res?.data?.data?.data[item]
                        }));
                    }
                })
                setParentDetails({
                    student_aadhar_number : res?.data?.data?.data?.aadhar_number?.number,
                    student_aadhar_file :res?.data?.data?.data?.aadhar_number?.file,
                    emergency_contact_name : res?.data?.data?.data?.emergency_contact?.name,
                    emergency_contact_mobile_number : res?.data?.data?.data?.emergency_contact?.mobile_number,
                    father_first_name : res?.data?.data?.data?.father_details?.first_name,
                    father_middle_name : res?.data?.data?.data?.father_details?.middle_name,
                    father_last_name : res?.data?.data?.data?.father_details?.last_name,
                    father_email_address : res?.data?.data?.data?.father_details?.email_address,
                    father_mobile_number : res?.data?.data?.data?.father_details?.mobile_number,
                    father_pan_number : res?.data?.data?.data?.father_details?.pan_number,
                    father_aadhar_number : res?.data?.data?.data?.father_details?.aadhar_number.number,
                    father_aadhar_file : res?.data?.data?.data?.father_details?.aadhar_number.file,
                    father_image_url : res?.data?.data?.data?.father_details?.father_image_url,
                    mother_first_name : res?.data?.data?.data?.mother_details?.first_name,
                    mother_middle_name : res?.data?.data?.data?.mother_details?.middle_name,
                    mother_last_name : res?.data?.data?.data?.mother_details?.last_name,
                    mother_email_address : res?.data?.data?.data?.mother_details?.email_address,
                    mother_mobile_number : res?.data?.data?.data?.mother_details?.mobile_number,
                    mother_pan_number : res?.data?.data?.data?.mother_details?.pan_number,
                    mother_aadhar_number : res?.data?.data?.data?.mother_details?.aadhar_number.number,
                    mother_aadhar_file : res?.data?.data?.data?.mother_details?.aadhar_number.file,
                    mother_image_url : res?.data?.data?.data?.mother_details?.mother_image_url,
                })
                if(res?.data?.data?.data?.academic_year.name === '' && res?.data?.data?.data?.academic_year !== null){
                    setIsStudentDataUploaded(true)
                } else{
                    setIsStudentDataUploaded(false)
                }
                if(res?.data?.data?.data?.academic_year !== null && res?.data?.data?.data?.academic_year?.name !== ''){
                    setSelectedFeeTermData(res?.data?.data?.data || {})
                    setUpdatedFeeData(res?.data?.data?.data?.fee_term || [])
                    setSelectedDropDownValue(res?.data?.data?.data?.fee_term?.[0]?.feeterm_name || '')
                    setSelectedObjects(res?.data?.data?.data?.optional_subject || [])
                    setUpdatedFeeData(res?.data?.data?.data?.fee_term?.[0] || [])
                }

            } catch (error) {
                console.log(error)
                setToastErrorMessage(error?.response?.data?.message || "Something went wrong");
            } finally {
                setLoadingPage(false)
            }
        },
        [],
    )

    /* The above code is a JavaScript React function component. It defines a function called
    `getAddress` using the `useCallback` hook. */
    const getAddress =useCallback(
        async()=>{
            if(studentDetails.pin_code?.length < 6 ){
                setStudentDetails((prv)=>({
                    ...prv,
                    "state":'',
                    "city":''
                }))  
            }
            if(studentDetails.pin_code?.length===6){
                try {
                    const res =await dataService.GetAPI(`institution/get-city-state/${studentDetails.pin_code}`);
                    
                    const stateCopy={...studentDetails};
                    stateCopy.city=res.data.data.city;
                    stateCopy.state=res.data.data.state;
                    if(res?.data?.data?.state === "" || res?.data?.data?.state === undefined) {
                        setStateStatusDisable(false);
                    }
                    else{
                        setStateStatusDisable(true)
                    }
                    setStudentDetails(stateCopy)
                } catch (error) {
                    setStateStatusDisable(false);
                    setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
                    // setMandatoryErrorMessage(error?.response?.data?.message)
                }
            }
        },
        [studentDetails.pin_code],
    )

    const getBranchDetails = async() => {
        const branch_id = await GetBranchId()
        setBranchId(branch_id)
        const res = await dataService.GetAPI(`branch/${branch_id}`, true);
        setBranchName(res?.data?.data.branch_name)
    }

    /**
     * The function `getAcademicyears` retrieves ongoing and upcoming academic years from an API and
     * sets the retrieved data to the state variable `AcademicYear`.
     */
    const getAcademicyears = async () => {
        const branch_id = await GetBranchId()
        let endpoint = `academic-years?filter=true&branch_id=${branch_id}&status=ongoing,upcoming`
        const response = await dataService.GetAPI(endpoint, true);
        const temp = (response.data?.data?.data);
        setAcademicYear(temp)
    }

    /**
     * The function `getClasses` is an asynchronous function that retrieves classes data from an API
     * and sets it to the `Classes` state variable.
     */
    const getClasses = async () => {
        const branch_id = await GetBranchId()
        let endpoint = `classes?branch_id=${branch_id}&filter=true&status=true&role=directory`
        const response = await dataService.GetAPI(endpoint, true);
        const temp = (response.data?.data?.data);
        setClasses(temp)
    }

    /**
     * The function `getOptionalSubjects` retrieves optional subjects based on certain filters and sets
     * the sections and selected section state variables.
     */
    const getOptionalSUbjects=async()=>{
        if(    sectionName === '' 
            || studentDetails?.classes?.class_id ==='' 
            || studentDetails?.academic_year?.academic_year_id==='') return
        try{
            setSectionsLoading(true)
            let selectedSectionFromState=""
            const branch_id = await GetBranchId()
            let endpoint = `associations?branch_id=${branch_id}&filter=true&academic_year_id=${studentDetails?.academic_year?.academic_year_id}&class_id=${studentDetails?.classes?.class_id}&is_optional=true&role=directory`
            const response=await dataService.GetAPI(endpoint, true)
            const temp=(response.data?.data?.association)
            let newSection ;
            if(temp?.length !== 0) newSection = temp?.find(sec => sec.section_id === studentDetails?.sections.section_id);
            if(edit && !hasStartDateBegun && !didAcademicDropDownChange){
                if (!studentDetails?.has_invoice) {
                    setStudentDetails(prev => ({
                        ...prev,
                        sections: {
                            ...prev.sections,
                            section_name: newSection?.section_name || prev.sections.section_name, // Fallback to existing name if not found
                        },
                    }));
                }
            }
            if(!studentDetails?.has_invoice) { 
                if(temp?.length !== 0) selectedSectionFromState = temp?.find((section) => section?.section_name === sectionName);  
            } else {
                if(temp?.length !== 0) selectedSectionFromState = temp?.find((section) => section?.section_name === newSection?.section_name)
            }
            setSections(temp)    
            setSelectedSection(selectedSectionFromState);
            setOptionalSubjects(selectedSectionFromState?.optional_subjects || []);
            setMandatorySubjects(selectedSectionFromState?.mandatory_subjects || []);
            setStudentDetails((prv) => ({
                ...prv,
                "mandatory_subject": selectedSectionFromState?.mandatory_subjects || [],
            }));
            if(edit && hasStartDateBegun ){
                setOptionalSubjects(studentDetails?.optional_subject || []);
                setMandatorySubjects(studentDetails?.mandatory_subject || []);
            }

            // Create a map of subject_id to updated subject from the API response
            const subjectMap = new Map(
                (selectedSectionFromState?.optional_subjects || []).map((subject) => [
                    subject.subject_id,
                    {
                        ...subject,
                        amount: subject.amount ? String(subject.amount) : undefined, // Ensure amount is a string if present
                    }
                ])
            );
            //Create an array of objects with the same format, where the subject_id matches between studentDetails and selectedSectionFromState
            const filteredSubjects = studentDetails?.optional_subject?.filter((studentSubject) => {
                return selectedSectionFromState?.optional_subjects?.some(
                    (sectionSubject) => sectionSubject?.subject_id === studentSubject?.subject_id
                );
            });
            
            // Create an array of objects in the desired format
            const newArrayOfObjects = filteredSubjects?.map((subject) => ({
                subject_id: subject?.subject_id,
                subject_name: subject?.subject_name,
                amount: subject.amount ? String(subject.amount) : undefined // Default amount if not available
            }));
            
            let objects = edit && !didAcademicDropDownChange ? newArrayOfObjects : selectedObjects
            // Update selectedObjects based on the API response
            const updatedSelectedObjects = objects.map((obj) => {
                // Find the corresponding updated subject from the API response
                const updatedSubject = subjectMap.get(obj.subject_id);
    
                // If there's an updated subject with amount in API response, include it; otherwise, remove amount
                if (updatedSubject && updatedSubject.amount) {
                    return {
                        ...obj,
                        ...updatedSubject, // Include amount from API response
                    };
                }
    
                // Remove amount if it's not present in the API response
                const { amount, ...rest } = obj;
                return {
                    ...rest, // Remove amount
                };
            });
            // Filter out the objects not present in selectedSectionFromState.optional_subjects
            const filteredObjects = updatedSelectedObjects.filter(obj => 
                selectedSectionFromState?.optional_subjects.some(selectedObj => selectedObj.subject_id === obj.subject_id)
            );            // Set the updated selected objects
            setSelectedObjects(filteredObjects);
    
            setSectionsLoading(false)
        } catch (error){
            setSectionsLoading(false)
            setOptionalSubjects([]);
            setMandatorySubjects([]);
            setStudentDetails((prv) => ({
                ...prv,
                "mandatory_subject": []
            }));
            console.log('error', error)
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong");
        }

    }  

    /**
     * The function `getFeeStructure` retrieves the fee structure for a student based on their academic
     * year and class name.
     */
    function extractId(data) {
        return {
            subject_id : data.subject_id
        };
    }
    const getFeeStructure=async()=>{
        try{
            if(    hasStartDateBegun 
                || studentDetails?.academic_year?.academic_year_id===''
                || studentDetails?.classes?.class_id==='' 
                || sectionsLoading) return;
            setFeeStructureLoading(true)
            const branch_id = await GetBranchId()
            const selectedOptionalSubjectsIDs = selectedObjects.map(extractId);
            let body = {
                "branch_id":branch_id,
                "academic_year_id": studentDetails?.academic_year?.academic_year_id,
                "class_id": studentDetails?.classes?.class_id,
                "status": true,
                "role" : "directory",
            }
            if (selectedOptionalSubjectsIDs.length) {
                body.optional_subject_checked = selectedOptionalSubjectsIDs;
            }
            if(studentDetails.academic_year !== null) {
                let endpoint = `fee-structures/students-fee-structure`
                const response = await dataService.PostAPI(body, endpoint)
                if((response.data?.data?.data?.length===0)){
                    setSelectedDropDownValue('')
                    setStudentDetails((prv) => ({
                        ...prv,
                        fee_structure : {},
                        fee_term : []
                    }));
                    setStudentDetails(prev => {
                        const { fee_term_id, ...rest } = prev;
                        return rest;
                    });
                }
                const temp=(response.data?.data?.data)
                setFeeStructure(temp)
                setStudentDetails((prv) => ({
                    ...prv,
                    fee_structure : null,
                }));
                !edit && setSelectedDropDownValue('')
            }
        } catch {
            setFeeStructureLoading(false)
        } finally {
            setFeeStructureLoading(false)
        }
    }

    /* The above code is using the useEffect hook in React to call the getAddress function. The
    useEffect hook is used to perform side effects in functional components, such as fetching data
    or subscribing to events. In this case, the getAddress function is being called when the
    component mounts or when the getAddress function changes. */
    useEffect(() => {
        getAddress()
    }, [getAddress])


    /* The above code is a useEffect hook in a React component. It is triggered whenever the value of
    `selectedFeeTermData` changes. */
    useEffect(() => {
        if (edit) {
            let startDate = '';
    
            // Check if terms or fee_term exist before accessing start_date
            if (didDropDownChange && selectedFeeTermData?.terms?.[0]?.start_date) {
                startDate = new Date(selectedFeeTermData.terms[0].start_date);
            } else if (selectedFeeTermData?.fee_term?.[0]?.start_date) {
                startDate = new Date(selectedFeeTermData.fee_term[0].start_date);
            }
        
            if (!isSelectFeeTermDropdown) {
                if (startDate !== '' &&  studentDetails?.has_invoice) {
                    setHasStartDateBegun(true);
                } else {
                    setHasStartDateBegun(false);
                }
            }
        }
    }, [selectedFeeTermData, tabs]);

    useEffect(()=>{
        if(tabs === 'fee structure') getFeeStructure()
    },[selectedObjects, tabs, sectionsLoading])

        
    /* The above code is using the useEffect hook in React to perform certain actions when the
    dependencies change. */
    useEffect(()=>{
        if (tabs === 'academic'){            
            if(sectionName !== '') {
                getOptionalSUbjects(); 
                getFeeStructure()
            }  
        }
    }, [sectionName, academicYear,  classes, tabs ])

    useEffect(()=>{
        if(    edit 
            && !hasStartDateBegun 
            && !didAcademicDropDownChange 
            && !studentDetails?.has_invoice 
            && academicYear.length !== 0 
            && classes.length !==0 
            && sections.length!==0){
            // Update student details after the academic years and classes are fetched
            const newAcademicYear = academicYear?.find(ay => ay._id === studentDetails?.academic_year?.academic_year_id);
            const newClass = classes?.find(cls => cls._id === studentDetails?.classes?.class_id);
            const newSection = sections.find(sec => sec.section_id === studentDetails?.sections.section_id);
            setStudentDetails(prev => ({
                ...prev,
                academic_year: {
                    ...prev.academic_year,
                    name: newAcademicYear?.name || prev.academic_year.name, // Fallback to the existing name if not found
                },
                classes: {
                    ...prev.classes,
                    class_name: newClass?.name || prev.classes.class_name, // Fallback to the existing name if not found
                },
                sections: {
                    ...prev.sections,
                    section_name: newSection?.section_name || prev.sections.section_name, // Fallback to existing name if not found
                },
            }));
            if(newAcademicYear === undefined){
                setStudentDetails(prev => ({
                    ...prev,
                    "academic_year": {
                        "name": '',
                        "start_date": '',
                        "end_date": '',
                        "academic_year_id" : '',
                    },
                    "classes":{
                        "class_name": "",
                        "class_id": ""
                    },
                    "sections":{
                        "section_name": "",
                        "section_id": ""
                    },
                    "mandatory_subject": [
                        {
                            "subject_id": "",
                            "subject_name": ""
                        }
                    ],
                    "optional_subject" : [
                        {
                            "subject_id": "",
                            "subject_name": "",
                            "amount": ""
                        }
                    ]
                }));
                setSectionName('')
                setSelectedObjects([]);                
                setSelectedDropDownValue('');
                setSelectedFeeTermData({});
                setOptionalSubjects([]);
                setMandatorySubjects([]);
                setStudentDetails(prev => {
                    const { fee_term_id, ...rest } = prev;
                    return rest;
                });
            }
            if(newClass === undefined){
                setStudentDetails(prev => ({
                    ...prev,
                    "classes":{
                        "class_name": "",
                        "class_id": ""
                    },
                    "sections":{
                        "section_name": "",
                        "section_id": ""
                    },
                    "mandatory_subject": [
                        {
                            "subject_id": "",
                            "subject_name": ""
                        }
                    ],
                    "optional_subject" : [
                        {
                            "subject_id": "",
                            "subject_name": "",
                            "amount": ""
                        }
                    ]
                }));
                setSectionName('')
                setSelectedObjects([]);                
                setSelectedDropDownValue('');
                setSelectedFeeTermData({});
                setOptionalSubjects([]);
                setMandatorySubjects([]);
                setStudentDetails(prev => {
                    const { fee_term_id, ...rest } = prev;
                    return rest;
                });
            }
            if(newSection === undefined){
                setStudentDetails(prev => ({
                    ...prev,
                    "sections":{
                        "section_name": "",
                        "section_id": ""
                    },
                    "mandatory_subject": [
                        {
                            "subject_id": "",
                            "subject_name": ""
                        }
                    ],
                    "optional_subject" : [
                        {
                            "subject_id": "",
                            "subject_name": "",
                            "amount": ""
                        }
                    ]
                }));
                setSectionName('')
                setSelectedObjects([]);                
                setSelectedDropDownValue('');
                setSelectedFeeTermData({});
                setOptionalSubjects([]);
                setMandatorySubjects([]);
                setStudentDetails(prev => {
                    const { fee_term_id, ...rest } = prev;
                    return rest;
                });
            }
        } 
    },[sectionName, academicYear, classes, sections, tabs])

        
    /* The above code is a useEffect hook in a React component. It is used to perform side effects in a
    functional component. */
    useEffect(() => {
        const fetchData = async () => {
            try {
                const queryString = window.location.search;
                const searchParams = new URLSearchParams(queryString);
                setParams(searchParams.toString());
    
                // Wait for branch details to be fetched
                await getBranchDetails();
    
                // Check if it's in edit mode and get view details
                if (edit) {
                    await getViewDetails();
                } else {
                    setLoadingPage(false);
                }
                    
                // Fetch fee structure if academic year and class are available
                if (studentDetails.academic_year.name !== '' && studentDetails.classes.class_name) {
                    await getFeeStructure();
                }  
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
    
        fetchData(); // Call the async function
    
    }, []);

    useEffect(()=>{
        const fetchData = async () => {
            try{
                // Fetch academic years and classes
                await getAcademicyears();
                await getClasses();          
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
        fetchData(); // Call the async function
    },[tabs])
    

    return (
        <>
            <CardHeader noPadding classkey={"overflow-y-hidden"}>
                <div
                    class="mainDataCntnrTop shadow-s13"
                    style={{ position: "sticky", position: -"webkit-sticky;" }}
                >
                    <h5 class="pageHeader adderror">
                        {edit ? "Edit" : "Add"} Student
                    </h5>
                    <div class="flex items-center">
                        <button
                            onClick={() => cancelHandler()}
                            type="button"
                            class="cancl-btn"
                        >
                            Cancel
                        </button>
                        <button
                            disabled={loading}
                            type="submit"
                            id="sumbit-button"
                            class="actn-btn onboardInstitution"
                            onClick={() => handleSaveAndProcced()}
                            style={{ 
                                ...(loading && {
                                    width: (edit ? "96px" : "auto"),
                                    cursor: 'not-allowed' 
                                })
                            }}
                        >
                            {!loading ? (
                                (tabs === 'fee structure') ? (
                                    edit ? "Update" : "Save"
                                ) : (
                                    "Save & Proceed"
                                )
                            ) : (
                                <span>{<Loader />}</span>
                            )}
                        </button>
                    </div>
                </div>
                {/* <LoadingOverlay
                    active={edit ? loadingPage : false}
                    spinner
                    text="Loading Student details..."
                > */}
                {edit && loadingPage ? <CustomOverLay Active text="Loading..." classKey={`flex flex-col justify-center items-center sidebarOpenedOverlay`}/>:<div>
                    <div class="h-[calc(100vh-70px)]">
                        <div class="overflow-y-auto scrollBar-hidden pt-[24px] pb-5">
                            <div class="flex justify-center border-b pb-[10px]">
                                <div>
                                    <div class="flex items-center justify-center">
                                        <div class="w-[30px] h-[30px] rounded-full border-[6px] border-[#106EB4] bg-[#fff] z-[1]"></div>
                                        <div class={`w-[150px] h-2 -mx-[1px] ${(tabs === 'contact' || tabs === 'academic' || tabs === 'fee structure') ? 'bg-[#106EB4] ' : 'bg-[#D9D9D9]' }`}></div>
                                        <div class={`w-[30px] h-[30px] rounded-full border-[6px] z-[1] ${(tabs === 'contact' || tabs === 'academic'|| tabs === 'fee structure') ? 'border-[#106EB4]' : 'border-[#D9D9D9]' } bg-[#fff]`}></div>
                                        <div class={`w-[150px] h-2 -mx-[1px] ${(tabs === 'academic'|| tabs === 'fee structure') ? 'bg-[#106EB4]' : 'bg-[#D9D9D9]' }`}></div>
                                        <div class={`w-[30px] h-[30px] rounded-full border-[6px] z-[1] ${(tabs === 'academic'|| tabs === 'fee structure') ? 'border-[#106EB4]' : 'border-[#D9D9D9]' } bg-[#fff]`}></div>
                                        <div class={`w-[150px] h-2 -mx-[1px] ${tabs === 'fee structure' ? 'bg-[#106EB4]' : 'bg-[#D9D9D9]' }`}></div>
                                        <div class={`w-[30px] h-[30px] rounded-full border-[6px] z-[1] ${tabs === 'fee structure' ? 'border-[#106EB4]' : 'border-[#D9D9D9]' } bg-[#fff]`}></div>
                                    </div>
                                    <div class="flex justify-center">
                                        {tabArray.map((item) => (
                                            <p
                                                onClick={() => handleTabs(item.toLowerCase())}
                                                key={item}
                                                class={`pt-[7px] text-f7 cursor-pointer ${
                                                    (tabAllArray.includes(item.toLowerCase()) ||
                                                        (tabs === "academic"  && (item.toLowerCase() === "contact"|| item.toLowerCase() === 'academic')) ||
                                                        (tabs === "fee structure" && item.toLowerCase() === "fee structure") ||
                                                        (tabs === 'fee structure'))
                                                        ? "font-semibold"
                                                        : "font-normal"
                                                } text-[#031624] w-[180px] text-center `}
                                            >
                                                {item === "Fee Structure" ? "Fee Structure" : `${item} Details`}
                                            </p>
                                        ))}
                                    </div>
                                </div>
                            </div>
                            <div className="overflow-auto scroll-bar min-h-minheight1 max-h-maxheight1 px-[40px]">
                                <div class={`w-[88%] 2xl:w-[65%] mx-auto mt-4 pb-[130px]`}>
                                    {tabs === "basic" && (
                                        <BasicDetails
                                            edit={edit}
                                            studentDetails={studentDetails}
                                            setStudentDetails={setStudentDetails}
                                            handleInput={handleInput}
                                            handleParentInput={handleParentInput}
                                            handleDropdown={handleDropdown}
                                            showDropdown={showDropdown}
                                            submitSelected={submitSelected}
                                            setsubmitSelected={setsubmitSelected}
                                            handleDropDownValue={handleDropDownValue}
                                            handleUploadAadhaar={handleUploadAadhaar}
                                            handleSelectedDate={handleSelectedDate}
                                            imageSizeInfoHover={imageSizeInfoHover}
                                            setImageSizeInfoHover={setImageSizeInfoHover}
                                            setformatError={setformatError}
                                            setimageLoading={setimageLoading}
                                            setToastErrorMessage={setToastErrorMessage}
                                            parentDetails={parentDetails}
                                            setParentDetails={setParentDetails}
                                            customError={customError}
                                            setshowDropdown={setshowDropdown}
                                        />
                                    )}
                                    {tabs === "contact" && (
                                        <ContactDetails
                                            edit={edit}
                                            handleCheckbox={handleCheckbox}
                                            handleDropdown={handleDropdown}
                                            showDropdown={showDropdown}
                                            studentDetails={studentDetails}
                                            setStudentDetails={setStudentDetails}
                                            handleInput={handleInput}
                                            handleParentInput={handleParentInput}
                                            submitSelected={submitSelected}
                                            setsubmitSelected={setsubmitSelected}
                                            handleDropDownValue={handleDropDownValue}
                                            imageSizeInfoHover={imageSizeInfoHover}
                                            setImageSizeInfoHover={setImageSizeInfoHover}
                                            setformatError={setformatError}
                                            setimageLoading={setimageLoading}
                                            parentDetails={parentDetails}
                                            setParentDetails={setParentDetails}
                                            stateStatus={stateStatus}
                                            setcustomError={setcustomError}
                                            customError={customError}
                                            isValidation={isValidation}
                                            setToastErrorMessage={setToastErrorMessage}
                                            handleParentCheckbox={handleParentCheckbox}
                                        />
                                    )}
                                    {tabs === "academic" && (
                                        <AcademicDetails
                                            handleDropdown={handleDropdown}
                                            showDropdown={showDropdown}
                                            academicYears={academicYear}
                                            optionalSubjects={optionalSubjects}
                                            classes={classes}
                                            branch_id={branch_id}
                                            sectionsLoading={sectionsLoading}
                                            setSectionsLoading={setSectionsLoading}
                                            branch_name={branch_name}
                                            setSelectedDropDownValue={setSelectedDropDownValue}
                                            submitSelected={submitSelected}
                                            setsubmitSelected={setsubmitSelected}
                                            studentAcademicDetails={studentDetails}
                                            setStudentAcademicDetails={setStudentDetails}
                                            selectedObjects={selectedObjects}
                                            setSelectedObjects={setSelectedObjects}
                                            selectedSections={selectedSections}
                                            setSelectedSections={setSelectedSections}
                                            setMandatorySubjects={setMandatorySubjects}
                                            mandatorySubjects={mandatorySubjects}
                                            sectionName={sectionName}
                                            setSectionName={setSectionName}
                                            didAcademicDropDownChange={didAcademicDropDownChange}
                                            setAcademicDidDropDownChange={setAcademicDidDropDownChange}
                                            setOptionalSubjects={setOptionalSubjects}
                                            hasStartDateBegun={hasStartDateBegun}
                                            edit={edit}
                                            didDropDownChange={didDropDownChange}
                                        />
                                    )}
                                    {tabs === "fee structure" && (
                                        <FeeStructure 
                                            edit={edit}
                                            handleDropdown={handleDropdown}
                                            showDropdown={showDropdown}
                                            academicYears={academicYear}
                                            optionalSubjects={optionalSubjects}
                                            classes={classes}
                                            branch_id={branch_id}
                                            branch_name={branch_name}
                                            submitSelected={submitSelected}
                                            setsubmitSelected={setsubmitSelected}
                                            studentDetails={studentDetails}
                                            selectedObjects={selectedObjects}
                                            setSelectedObjects={setSelectedObjects}
                                            feeStructure={feeStructure}
                                            setFeeStructure={setFeeStructure}
                                            getFeeStructure={getFeeStructure}
                                            feeStructureLoading={feeStructureLoading}
                                            selectedFeeTermData={selectedFeeTermData}
                                            setSelectedFeeTermData={setSelectedFeeTermData}
                                            customError={customError}
                                            selectedDropDownValue={selectedDropDownValue}
                                            setSelectedDropDownValue={setSelectedDropDownValue}
                                            didDropDownChange={didDropDownChange}
                                            setDidDropDownChange={setDidDropDownChange}
                                            didAcademicDropDownChange={didAcademicDropDownChange}
                                            hasStartDateBegun={hasStartDateBegun}
                                            setHasStartDateBegun={setHasStartDateBegun}
                                            isStudentDataUploaded={isStudentDataUploaded}
                                            isSelectFeeTermDropdown={isSelectFeeTermDropdown}
                                            setIsSelectFeeTermDropdown={setIsSelectFeeTermDropdown}
                                            setStudentDetails={setStudentDetails}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>}
                {toastErrorMessage!=='' &&<Toast
                    message={toastErrorMessage}
                    type="error"
                    setToastmessage={setToastErrorMessage} />}
            </CardHeader>
        </>
    );
}

